// Phone helpers — backed by libphonenumber-js for proper international support.
// All values stored in form state are E.164 (e.g. "+447401115587"). UK is default.

import { parsePhoneNumberFromString, formatIncompletePhoneNumber } from 'libphonenumber-js/min';

const DEFAULT_COUNTRY = 'GB';

/** Returns the value as E.164 ("+447401115587"), or "" if it can't be parsed. */
export function toE164(raw, defaultCountry = DEFAULT_COUNTRY) {
  if (!raw) return '';
  // Already E.164?
  if (typeof raw === 'string' && raw.startsWith('+')) {
    const parsed = parsePhoneNumberFromString(raw);
    if (parsed?.isValid()) return parsed.number;
    return raw.replace(/[^\d+]/g, '');
  }
  const parsed = parsePhoneNumberFromString(String(raw), defaultCountry);
  return parsed?.number || '';
}

/** Pretty international display: "+44 7401 115 587". */
export function formatDisplay(raw, defaultCountry = DEFAULT_COUNTRY) {
  if (!raw) return '';
  const parsed = parsePhoneNumberFromString(
    String(raw).startsWith('+') ? String(raw) : String(raw),
    defaultCountry,
  );
  return parsed?.formatInternational?.() || String(raw);
}

/** Loose live formatter used by the legacy <PhoneInput>. The new component
 *  uses react-phone-number-input which handles this internally — kept for
 *  any direct callers. */
export function liveFormat(raw, defaultCountry = DEFAULT_COUNTRY) {
  if (!raw) return '';
  return formatIncompletePhoneNumber(String(raw), defaultCountry);
}

/** Digits-only (no leading "+") — what WhatsApp's `wa.me/<digits>` wants. */
export function toWhatsAppDigits(raw, defaultCountry = DEFAULT_COUNTRY) {
  const e = toE164(raw, defaultCountry);
  return e.startsWith('+') ? e.slice(1) : e.replace(/\D/g, '');
}
